import React, { useState } from 'react'
import { Form, Col, Row, Tab } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { IconEdit } from '../../assets/icons'

const DefaultTab = (props) => {

  const [ editDefault, setEditDefault ] = useState(false)

  const {t} = props
  return(
    <Tab.Pane eventKey={props.eventKey}>
      <h4>{t('localOffers-modal-tab-headline-default')}</h4>

      <Row noGutters>
        <Col md={8} lg={8} xs={8}>
          <p><strong>{t('localPosts-modal-tab-edit')}</strong></p>
        </Col>
        <Col md={4} lg={4} xs={4} className={'text-right'}>
          <IconEdit 
            onClick={() => setEditDefault(!editDefault)}
          />
        </Col>
      </Row>
      <Row noGutters>
        <Col md={12} lg={12}>
          <label>{t('input-form-state')}</label>
          {editDefault ?
          <>
          <Form.Group controlId="state" >
            <Form.Control defaultValue={props.state} onChange={props.handleOnChange} as="select" >
              <option key={'active'} value={'active'}>{t(`foodMenus-table-active`)}</option>
              <option key={'inactive'} value={'inactive'}>{t(`foodMenus-table-inactive`)}</option>
            </Form.Control>
          </Form.Group>
          </> 
          :
          <p className="font-weight-bold" >{t(`foodMenus-table-${props.state}`)}</p>
          }
        </Col>
        <Col md={6} lg={6}>
        <label>{t('input-form-name')}</label>
        {editDefault ?
        <>
        <Form.Group controlId="name" >
          <Form.Control type={'text'} onChange={props.handleOnChange} defaultValue={props.name}/>
        </Form.Group>
        </> 
        :
        <p className="font-weight-bold" >{props.name}</p>
        }
        </Col>
        <Col md={6} lg={6}>
          <label>{t('foodMenus-table-sku')}</label>
          {editDefault ?
          <>
          <Form.Group controlId="sku" >
            <Form.Control type={'text'} onChange={props.handleOnChange} defaultValue={props.sku}/>
          </Form.Group>
          </> 
          :
          <p className="font-weight-bold" >{props.sku}</p>
          }
        </Col>
        <Col md={6} lg={6}>
        <label>{t('input-form-price')}</label>
        {editDefault ?
        <>
        <Form.Group controlId="price" >
          <Form.Control type={'number'} onChange={props.handleOnChange} defaultValue={props.price}/>
        </Form.Group>
        </> 
        :
        <p className="font-weight-bold" >{props.price}</p>
        }
        </Col>
        <Col md={6} lg={6}>
          <label>{t('input-form-size')}</label>
          {editDefault ?
          <>
          <Form.Group controlId="size" >
            <Form.Control type={'text'} onChange={props.handleOnChange} defaultValue={props.size}/>
          </Form.Group>
          </> 
          :
          <p className="font-weight-bold" >{props.size}</p>
          }
        </Col>
        <Col md={12} lg={12}>
        <label>{t('input-form-description')}</label>
        {editDefault ?
        <>
        <Form.Group controlId="description" >
          <Form.Control 
            as="textarea"
            rows={5} 
            onChange={props.handleOnChange} 
            defaultValue={props.description}
          />
        </Form.Group>
        </> 
        :
        <p className="font-weight-bold" >{props.description}</p>
        }
        </Col>
      </Row>
    </Tab.Pane>
  )
}

export default (withTranslation()(DefaultTab))